import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

/* ================= ASYNC THUNKS ================= */

export const loadUpdateProfileData = createAsyncThunk(
  "updateProfile/loadData",
  async ({ userId, actions }, thunkAPI) => {
    try {
      if (userId && actions?.getUserProfile) {
        actions.getUserProfile(userId);
      }

      if (actions?.getSettingData && actions?.getAllProgrammes) {
        actions.getSettingData();
        actions.getAllProgrammes();
      }

      return true;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

/* ================= SLICE ================= */

const updateProfile1Slice = createSlice({
  name: "updateProfile1",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadUpdateProfileData.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadUpdateProfileData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(loadUpdateProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default updateProfile1Slice.reducer;
